import { useEffect } from 'react';
import {
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import {
  type CollectionListItem,
  type GetCollectionsParams,
  type PaginatedCollectionsResponse,
} from '../types';
import { collectionApi } from '../api';
import { collectionKeys } from './collection.keys';

// Query de listagem de collections
export function useCollections(
  filters?: GetCollectionsParams,
  options?: Omit<UseQueryOptions<PaginatedCollectionsResponse, Error>, 'queryKey' | 'queryFn'>
) {
  const query = useQuery({
    queryKey: collectionKeys.list(filters),
    queryFn: ({ signal }) => collectionApi.list(filters, signal),
    staleTime: 60_000,
    ...(options as Omit<UseQueryOptions<PaginatedCollectionsResponse, Error>, 'queryKey' | 'queryFn'>),
  });

  useEffect(() => {
    if (!query.error) return;
    toast({
      title: 'Erro ao buscar coleções',
      description: query.error.message,
      variant: 'destructive',
    });
  }, [query.error]);

  return {
    collections: query.data?.data ?? [],
    totalPages: query.data?.totalPage,
    totalItems: query.data?.totalItems ?? 0,
    currentPage: query.data?.page ?? filters?.page ?? 1,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
    queryResult: query,
  };
}
